import { Location } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { finalize } from "rxjs/operators";
import { AuthenticationService } from "../../../../core/authentication/authentication.service";
import { DynamicFormComponent } from "../../../../shared/components/dynamic-form/dynamic-form.component";
import { NotificationService } from "../../../../shared/components/notification/notification.service";
import { UserInfo } from "../../../../shared/types/user-info";
import { InternalProviderService } from "../internal-provider.service";
import { InternalProvider } from "../internal-provider.type";
import { CreateInternalProviderService, ICreateInternalForm } from "./create-internal-provider.service";

@Component({
  selector: "app-create-internal-provider",
  templateUrl: "./create-internal-provider.component.html",
  styleUrls: ["./create-internal-provider.component.css"],
  providers: [CreateInternalProviderService],
})
export class CreateInternalProviderComponent implements OnInit {
  @ViewChild(DynamicFormComponent) dynamicForm: DynamicFormComponent;
  currentUser: UserInfo;
  createLocationsForm: FormGroup;
  questions: any;

  constructor(
    public location: Location,
    private router: Router,
    private configsService: InternalProviderService,
    private questionsService: CreateInternalProviderService,
    private notificationService: NotificationService,
    private authenticationService: AuthenticationService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  ngOnInit(): void {
    this.questionsService.generateQuestions({}).subscribe((qs) => {
      this.questions = qs;
    });
  }

  goBack(): void {
    this.location.back();
  }

  onSubmit(values: ICreateInternalForm): void {
    this.configsService
      .createInternalProvider({ ...values })
      .pipe(finalize(() => this.dynamicForm.enable()))
      .subscribe(
        (ip: InternalProvider) => {
          this.notificationService.success("Internal provider successfully created");
          this.router.navigate([`/internal-providers/${ip.id}`]);
        },
        (error) => {
          this.notificationService.error(error.errors ? error.errors[0].message : "Could not create internal provider");
        },
      );
  }
}
